module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "karsten-boehm.ce6b4f01.jpg" + "?" + Date.now();